import type { ICoreCodeBlock } from '@ingenico/react-ui/core-code-block';
import type { ModuleItemField } from '../../domain/models/snapshot.model';
import type { EnumLogicalDeviceRoleApi } from '@ingenico/api-sdk-device-management-private-v2';

export enum ParameterFileFormat {
  JSON = 'JSON',
  XML = 'XML',
}

export interface ParameterOutputFiles {
  readonly fileFormat?: ParameterFileFormat;
  readonly fileName?: string;
}

export interface ParameterOutputFileDevice {
  readonly logicalDeviceName?: string;
  readonly logicalDeviceId?: string;
  readonly logicalDeviceRoleSnapshot?: EnumLogicalDeviceRoleApi;
  readonly outputFiles: ParameterOutputFiles[];
}

export interface IndexedParameterOutputFileDevice {
  readonly device: ParameterOutputFileDevice;
  readonly index: number;
}

export interface ParameterOutputFileModalModel {
  readonly parameterSetId: string;
  readonly templateId: string;
  readonly templateName: string;
  readonly devices: ParameterOutputFileDevice[];
}

export interface ParameterOutputFileModalProps {
  readonly deploymentUnitId: string;
  readonly deviceId?: string;
  readonly configurationId?: string;
  readonly moduleItemField?: ModuleItemField | undefined;
  readonly onCancel: () => void;
  readonly onBack: () => void;
  readonly isOpen: boolean;
}

export interface UseParameterOutputFileModalProps {
  readonly deploymentUnitId: string;
  readonly deviceId?: string;
  readonly configurationId?: string;
  readonly moduleItemField?: ModuleItemField;
  readonly isOpen: boolean;
}
export interface UseParameterOutputFileModalReturn {
  readonly code: ICoreCodeBlock['code'];
  readonly isError: boolean;
  readonly isSuccess: boolean;
  readonly errorMessage: string;
  readonly isLoading: boolean;
  readonly isLoadingCode: boolean;
  readonly language: ICoreCodeBlock['language'];
  readonly moduleName: ModuleItemField['name'];
  readonly moduleVersion: ModuleItemField['version'];
  readonly devices: ParameterOutputFileModalModel['devices'];
  readonly visibleDevices: IndexedParameterOutputFileDevice[];
  readonly deviceSearch: string;
  readonly onDeviceSearchChange: (input: string) => void;
  readonly onSelectOutputFilename: (input: string) => void;
  readonly onSelectDevice: (index: number) => void;
  readonly onSelectTemplate: (input: string) => void;
  readonly outputFilename: ICoreCodeBlock['title'];
  readonly outputFiles: ParameterOutputFiles[];
  readonly selectedOutputFilename: ParameterOutputFiles['fileName'] | undefined;
  readonly selectedDeviceIndex: number;
  readonly selectedTemplateId: ParameterOutputFileModalModel['templateId'] | undefined;
  readonly templates: ParameterOutputFileModalModel[];
  readonly downloadOutputFile?: () => void;
}

export enum ParameterOutputFileModalLifecycle {
  LoadingBoth = 0,
  LoadingCode = 1,
  Error = 2,
  Success = 3,
}
